import React, { useState } from 'react';

const AIVariations = () => {
  const [expandedCode, setExpandedCode] = useState({});
  const [selectedGeneration, setSelectedGeneration] = useState('all');

  const toggleCode = (id) => {
    setExpandedCode(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  return (
    <div style={{
      maxWidth: '1200px',
      margin: '30px auto',
      padding: '0 20px'
    }}>
      <h2 style={{ 
        margin: '0 0 30px 0', 
        fontSize: '32px',
        color: '#4ECDC4',
        fontWeight: '700'
      }}>
        🧬 AI Variations: Single File Evolution
      </h2>
      
      {/* How it works section */}
      <div style={{
        background: 'linear-gradient(135deg, rgba(78, 205, 196, 0.1), rgba(150, 206, 180, 0.1))',
        padding: '25px',
        borderRadius: '16px',
        border: '1px solid rgba(78, 205, 196, 0.3)',
        marginBottom: '30px'
      }}>
        <h3 style={{ 
          margin: '0 0 20px 0', 
          fontSize: '24px',
          color: '#4ECDC4'
        }}>
          How Artemis Single File Evolution Works
        </h3>
        
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '20px'
        }}>
          <div style={{
            background: 'rgba(255, 255, 255, 0.05)',
            padding: '20px',
            borderRadius: '10px',
            border: '1px solid rgba(255, 255, 255, 0.1)'
          }}>
            <h4 style={{ margin: '0 0 10px 0', color: '#96CEB4' }}>
              1️⃣ Initial Analysis
            </h4>
            <p style={{ margin: 0, fontSize: '14px', lineHeight: '1.6', opacity: 0.9 }}>
              • Static code analysis<br/>
              • Performance profiling<br/>
              • Identify bottlenecks<br/>
              • Extract patterns
            </p>
          </div>
          
          <div style={{
            background: 'rgba(255, 255, 255, 0.05)',
            padding: '20px',
            borderRadius: '10px',
            border: '1px solid rgba(255, 255, 255, 0.1)'
          }}>
            <h4 style={{ margin: '0 0 10px 0', color: '#96CEB4' }}>
              2️⃣ Multi-Agent Generation
            </h4>
            <p style={{ margin: 0, fontSize: '14px', lineHeight: '1.6', opacity: 0.9 }}>
              • Performance Expert Agent<br/>
              • Clean Code Agent<br/>
              • Memory Optimizer Agent<br/>
              • Domain Expert Agent
            </p>
          </div>
          
          <div style={{
            background: 'rgba(255, 255, 255, 0.05)',
            padding: '20px',
            borderRadius: '10px',
            border: '1px solid rgba(255, 255, 255, 0.1)'
          }}>
            <h4 style={{ margin: '0 0 10px 0', color: '#96CEB4' }}>
              3️⃣ Genetic Evolution
            </h4>
            <p style={{ margin: 0, fontSize: '14px', lineHeight: '1.6', opacity: 0.9 }}>
              • Mutation: Random improvements<br/>
              • Crossover: Combine best features<br/>
              • Selection: Elite solutions<br/>
              • Fitness scoring
            </p>
          </div>
          
          <div style={{
            background: 'rgba(255, 255, 255, 0.05)',
            padding: '20px',
            borderRadius: '10px',
            border: '1px solid rgba(255, 255, 255, 0.1)'
          }}>
            <h4 style={{ margin: '0 0 10px 0', color: '#96CEB4' }}>
              4️⃣ Iterative Refinement
            </h4>
            <p style={{ margin: 0, fontSize: '14px', lineHeight: '1.6', opacity: 0.9 }}>
              • Test each variation<br/>
              • Measure improvements<br/>
              • Apply feedback loops<br/>
              • Converge to optimal
            </p>
          </div>
        </div>
      </div>
      
      {/* Generation Filter */}
      <div style={{
        display: 'flex',
        gap: '10px',
        marginBottom: '20px',
        flexWrap: 'wrap'
      }}>
        <button
          onClick={() => setSelectedGeneration('all')}
          style={{
            padding: '8px 16px',
            background: selectedGeneration === 'all' ? '#4ECDC4' : 'rgba(78, 205, 196, 0.2)',
            color: selectedGeneration === 'all' ? 'white' : '#4ECDC4',
            border: '1px solid #4ECDC4',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '600',
            transition: 'all 0.2s ease'
          }}
        >
          All Generations
        </button>
        <button
          onClick={() => setSelectedGeneration('gen1')}
          style={{
            padding: '8px 16px',
            background: selectedGeneration === 'gen1' ? '#FF6B6B' : 'rgba(255, 107, 107, 0.2)',
            color: selectedGeneration === 'gen1' ? 'white' : '#FF6B6B',
            border: '1px solid #FF6B6B',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '600',
            transition: 'all 0.2s ease'
          }}
        >
          Generation 1
        </button>
        <button
          onClick={() => setSelectedGeneration('gen2')}
          style={{
            padding: '8px 16px',
            background: selectedGeneration === 'gen2' ? '#96CEB4' : 'rgba(150, 206, 180, 0.2)',
            color: selectedGeneration === 'gen2' ? 'white' : '#96CEB4',
            border: '1px solid #96CEB4',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '600',
            transition: 'all 0.2s ease'
          }}
        >
          Generation 2
        </button>
        <button
          onClick={() => setSelectedGeneration('final')}
          style={{
            padding: '8px 16px',
            background: selectedGeneration === 'final' ? '#DDA0DD' : 'rgba(221, 160, 221, 0.2)',
            color: selectedGeneration === 'final' ? 'white' : '#DDA0DD',
            border: '1px solid #DDA0DD',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '600',
            transition: 'all 0.2s ease'
          }}
        >
          Final Evolution
        </button>
      </div>
      
      <div style={{
        background: 'rgba(78, 205, 196, 0.1)',
        padding: '30px',
        borderRadius: '16px',
        border: '1px solid rgba(78, 205, 196, 0.3)',
        marginBottom: '30px'
      }}>
        <h3 style={{ 
          margin: '0 0 20px 0', 
          fontSize: '24px',
          color: '#4ECDC4'
        }}>
          File: api.py
        </h3>
        
        <div style={{
          background: 'rgba(0, 0, 0, 0.3)',
          padding: '20px',
          borderRadius: '10px',
          fontFamily: 'monospace',
          fontSize: '14px',
          marginBottom: '20px'
        }}>
          <div style={{ marginBottom: '15px', color: '#4ECDC4' }}>
            <strong>User:</strong> "Optimize the performance of my code"
          </div>
          <div style={{ marginBottom: '10px', fontSize: '12px', opacity: 0.8 }}>
            <em>Context: API endpoint handling data processing</em>
          </div>
        </div>

        {/* Original Code */}
        <div style={{
          background: 'rgba(255, 107, 107, 0.1)',
          padding: '20px',
          borderRadius: '10px',
          marginBottom: '20px',
          border: '1px solid rgba(255, 107, 107, 0.3)'
        }}>
          <h4 style={{ margin: '0 0 10px 0', color: '#FF6B6B' }}>
            🔴 Original Code (Performance Issues Detected)
          </h4>
          <div style={{
            background: 'rgba(0, 0, 0, 0.4)',
            padding: '15px',
            borderRadius: '8px',
            fontFamily: 'monospace',
            fontSize: '12px',
            color: '#ddd'
          }}>
            <pre style={{ margin: 0, whiteSpace: 'pre-wrap' }}>
{`def get_user_data(user_id):
    conn = create_connection()  # Creates new connection each time
    user = conn.query(f"SELECT * FROM users WHERE id={user_id}")  # SQL injection risk
    orders = conn.query(f"SELECT * FROM orders WHERE user_id={user_id}")
    
    # Process orders synchronously
    processed_orders = []
    for order in orders:
        # N+1 query problem
        items = conn.query(f"SELECT * FROM items WHERE order_id={order.id}")
        processed_orders.append({
            'order': order,
            'items': items
        })
    
    return {"user": user, "orders": processed_orders}`}
            </pre>
          </div>
          <div style={{
            marginTop: '10px',
            fontSize: '13px',
            color: '#FF6B6B'
          }}>
            ⚠️ Issues: SQL injection, N+1 queries, no connection pooling, synchronous processing
          </div>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <strong style={{ color: '#96CEB4', fontSize: '18px' }}>
            🧬 Artemis Evolution Process
          </strong>
        </div>
        
        {/* Generation 1 Label */}
        {(selectedGeneration === 'all' || selectedGeneration === 'gen1') && (
          <div style={{
            background: 'rgba(255, 107, 107, 0.1)',
            padding: '15px',
            borderRadius: '10px',
            marginBottom: '20px',
            border: '1px solid rgba(255, 107, 107, 0.3)',
            textAlign: 'center'
          }}>
            <h4 style={{ margin: 0, color: '#FF6B6B' }}>
              🌱 Generation 1: Initial AI Agent Solutions
            </h4>
            <p style={{ margin: '5px 0 0 0', fontSize: '13px', opacity: 0.8 }}>
              Each specialized agent creates their own optimization approach
            </p>
          </div>
        )}
        
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          {[
            {
              id: 'var1',
              generation: 'gen1',
              agent: '⚡ Performance Expert',
              version: 'Variation 1: Performance Focus',
              approach: 'Async/await optimization with connection pooling',
              changes: [
                'Convert synchronous operations to async/await',
                'Implement database connection pooling',
                'Add Redis caching layer for frequent queries',
                'Batch database operations where possible'
              ],
              codePreview: `async def get_user_data(user_id: int):
    async with connection_pool.acquire() as conn:
        # Parallel queries with caching
        user_task = cache.get_or_set(
            f"user:{user_id}",
            lambda: conn.fetch_one("SELECT * FROM users WHERE id=$1", user_id)
        )
        orders_task = conn.fetch_all(
            "SELECT * FROM orders WHERE user_id=$1", 
            user_id
        )
        
        user, orders = await asyncio.gather(user_task, orders_task)
        
        # Batch fetch all items for orders
        order_ids = [order['id'] for order in orders]
        items = await conn.fetch_all(
            "SELECT * FROM items WHERE order_id = ANY($1)",
            order_ids
        )
        
        # Group items by order
        items_by_order = defaultdict(list)
        for item in items:
            items_by_order[item['order_id']].append(item)
        
        return {
            "user": user, 
            "orders": [
                {"order": order, "items": items_by_order[order['id']]}
                for order in orders
            ]
        }`,
              metrics: { speed: '+45%', memory: '-20%', readability: '85%' },
              score: 3.7,
              color: '#FF6B6B'
            },
            {
              id: 'var2',
              generation: 'gen1',
              agent: '🧹 Clean Code Expert',
              version: 'Variation 2: Clean Architecture',
              approach: 'Repository pattern with dependency injection',
              changes: [
                'Implement repository pattern',
                'Add comprehensive error handling',
                'Use dependency injection',
                'Type hints and documentation'
              ],
              codePreview: `from typing import Optional, Dict, List, Any
import logging
from dataclasses import dataclass

@dataclass
class UserData:
    user: Dict[str, Any]
    orders: List[Dict[str, Any]]

class UserRepository:
    def __init__(self, db_pool: AsyncConnectionPool, cache: Cache):
        self.db = db_pool
        self.cache = cache
        self.logger = logging.getLogger(__name__)
    
    async def get_user_data(self, user_id: int) -> Optional[UserData]:
        """Retrieve user data with orders and items."""
        try:
            # Check cache first
            cached = await self._get_from_cache(user_id)
            if cached:
                return cached
            
            async with self.db.acquire() as conn:
                # Fetch user
                user = await self._fetch_user(conn, user_id)
                if not user:
                    self.logger.warning(f"User {user_id} not found")
                    return None
                
                # Fetch orders with items
                orders = await self._fetch_orders_with_items(conn, user_id)
                
                result = UserData(user=dict(user), orders=orders)
                await self._cache_result(user_id, result)
                
                return result
                
        except DatabaseError as e:
            self.logger.error(f"Database error for user {user_id}", exc_info=True)
            raise ServiceError(f"Failed to fetch user data: {str(e)}")`,
              metrics: { speed: '+25%', memory: '-10%', readability: '95%' },
              score: 4.1,
              color: '#96CEB4'
            },
            {
              id: 'var3',
              generation: 'gen1',
              agent: '💾 Memory Optimizer',
              version: 'Variation 3: Memory Efficient',
              approach: 'Streaming and lazy loading for minimal memory footprint',
              changes: [
                'Use async generators for streaming',
                'Implement pagination for large datasets',
                'Memory-efficient data structures',
                'Lazy loading with yield'
              ],
              codePreview: `from typing import AsyncGenerator, Dict, Any
import asyncio

async def get_user_data_stream(
    user_id: int, 
    page_size: int = 100
) -> AsyncGenerator[Dict[str, Any], None]:
    """Stream user data to minimize memory usage."""
    
    async with connection_pool.acquire() as conn:
        # Fetch user info first
        user = await conn.fetch_one(
            "SELECT * FROM users WHERE id = $1",
            user_id
        )
        
        if not user:
            return
        
        # Stream orders in batches
        offset = 0
        while True:
            orders_batch = await conn.fetch_all(
                """
                SELECT o.*, 
                       array_agg(
                           json_build_object(
                               'id', i.id,
                               'name', i.name,
                               'price', i.price
                           )
                       ) as items
                FROM orders o
                LEFT JOIN items i ON i.order_id = o.id
                WHERE o.user_id = $1
                GROUP BY o.id
                ORDER BY o.created_at DESC
                LIMIT $2 OFFSET $3
                """,
                user_id, page_size, offset
            )
            
            if not orders_batch:
                break
            
            # Yield each batch
            yield {
                "user": dict(user),
                "orders": [dict(order) for order in orders_batch],
                "has_more": len(orders_batch) == page_size
            }
            
            offset += page_size
            
            # Allow other tasks to run
            await asyncio.sleep(0)`,
              metrics: { speed: '+15%', memory: '-70%', readability: '88%' },
              score: 3.9,
              color: '#DDA0DD'
            },
            {
              id: 'var4',
              generation: 'gen2',
              agent: '🔀 Crossover Result',
              version: 'Generation 2: Hybrid Evolution',
              approach: 'Genetic crossover of best features from Gen 1',
              changes: [
                'Performance Agent\'s async/await + connection pooling',
                'Clean Code Agent\'s error handling + type safety',
                'Memory Optimizer\'s efficient data structures',
                'Added monitoring and observability'
              ],
              codePreview: `# Generation 2 - Evolved through crossover
from typing import Optional, Dict, Any, AsyncGenerator
import asyncio
from functools import lru_cache

class OptimizedUserService:
    def __init__(self, db_pool: AsyncConnectionPool, cache: RedisCache):
        self.db_pool = db_pool
        self.cache = cache
        self.logger = get_logger(__name__)
    
    async def get_user_data(self, user_id: int) -> Optional[Dict[str, Any]]:
        """Optimized user data retrieval with caching and parallel queries."""
        
        # Try cache first
        cache_key = f"user:{user_id}:full"
        cached = await self.cache.get(cache_key)
        if cached:
            self.logger.debug(f"Cache hit for user {user_id}")
            return cached
        
        async with self.db_pool.acquire() as conn:
            try:
                # Parallel execution of related queries
                user_task = conn.fetch_one(
                    "SELECT * FROM users WHERE id = $1",
                    user_id
                )
                orders_task = conn.fetch_all(
                    "SELECT * FROM orders WHERE user_id = $1 ORDER BY created_at DESC LIMIT 10",
                    user_id
                )
                stats_task = self._get_user_stats(conn, user_id)
                
                user, orders, stats = await asyncio.gather(
                    user_task, orders_task, stats_task
                )
                
                if not user:
                    return None
                
                result = {
                    "user": dict(user),
                    "recent_orders": [dict(order) for order in orders],
                    "stats": stats
                }
                
                # Cache with TTL
                await self.cache.set(cache_key, result, ttl=300)
                
                return result
                
            except Exception as e:
                self.logger.error(f"Error fetching user data", 
                                exc_info=True, 
                                extra={"user_id": user_id})
                raise
    
    @lru_cache(maxsize=1000)
    async def _get_user_stats(self, conn: AsyncConnection, user_id: int) -> Dict[str, Any]:
        """Get user statistics with local caching."""
        # Implementation details...`,
              metrics: { speed: '+50%', memory: '-25%', readability: '92%' },
              score: 4.6,
              color: '#96CEB4'
            },
            {
              id: 'var5',
              generation: 'final',
              agent: '🏆 Final Evolution',
              version: 'Final: Production-Ready Solution',
              approach: 'Best solution after 3 generations of evolution',
              changes: [
                'All performance optimizations validated',
                'Production-grade error handling',
                'Comprehensive test coverage',
                'Monitoring and alerting integrated',
                'Documentation and type safety'
              ],
              codePreview: `# Final Evolution - Production Ready
from typing import Optional, Dict, Any, TypedDict
import asyncio
from dataclasses import dataclass
from prometheus_client import Counter, Histogram
import structlog

# Metrics
request_counter = Counter('user_data_requests', 'Total requests')
request_duration = Histogram('user_data_duration', 'Request duration')
cache_hits = Counter('cache_hits', 'Cache hit count')

logger = structlog.get_logger()

class UserDataResponse(TypedDict):
    user: Dict[str, Any]
    orders: List[Dict[str, Any]]
    stats: Dict[str, Any]

@dataclass
class OptimizedUserService:
    """Production-ready user service with all optimizations."""
    
    db_pool: AsyncConnectionPool
    cache: RedisCache
    
    @request_duration.time()
    @request_counter.count_exceptions()
    async def get_user_data(
        self, 
        user_id: int,
        include_stats: bool = True
    ) -> Optional[UserDataResponse]:
        """
        Retrieve user data with optimal performance.
        
        Features:
        - Connection pooling
        - Parallel query execution
        - Smart caching with TTL
        - Comprehensive error handling
        - Performance monitoring
        - Type safety
        """
        log = logger.bind(user_id=user_id)
        
        # Check cache
        cache_key = f"user:{user_id}:v2"
        if cached := await self._get_cached(cache_key):
            cache_hits.inc()
            log.info("cache_hit")
            return cached
        
        try:
            async with self.db_pool.acquire() as conn:
                # Parallel queries with timeout
                async with asyncio.timeout(5.0):
                    user, orders = await asyncio.gather(
                        self._fetch_user(conn, user_id),
                        self._fetch_orders_with_items(conn, user_id),
                        return_exceptions=True
                    )
                
                # Handle errors
                if isinstance(user, Exception):
                    log.error("user_fetch_failed", exc_info=user)
                    raise ServiceError("Failed to fetch user")
                
                if not user:
                    log.warning("user_not_found")
                    return None
                
                # Build response
                response: UserDataResponse = {
                    "user": dict(user),
                    "orders": orders if not isinstance(orders, Exception) else [],
                    "stats": await self._get_stats(user_id) if include_stats else {}
                }
                
                # Cache result
                await self._cache_result(cache_key, response)
                
                log.info("user_data_fetched", order_count=len(response["orders"]))
                return response
                
        except asyncio.TimeoutError:
            log.error("request_timeout")
            raise ServiceError("Request timeout")
        except Exception as e:
            log.error("unexpected_error", exc_info=True)
            raise`,
              metrics: { speed: '+65%', memory: '-40%', readability: '94%' },
              score: 4.9,
              color: '#DDA0DD',
              best: true
            }
          ].filter(variant => 
            selectedGeneration === 'all' || 
            (selectedGeneration === 'gen1' && variant.generation === 'gen1') ||
            (selectedGeneration === 'gen2' && variant.generation === 'gen2') ||
            (selectedGeneration === 'final' && variant.generation === 'final')
          ).map((variation, i, arr) => {
            // Check if we need to show generation labels
            const showGen2Label = i > 0 && arr[i-1]?.generation !== 'gen2' && variation.generation === 'gen2' && (selectedGeneration === 'all' || selectedGeneration === 'gen2');
            const showFinalLabel = i > 0 && arr[i-1]?.generation !== 'final' && variation.generation === 'final' && (selectedGeneration === 'all' || selectedGeneration === 'final');
            
            return (
              <React.Fragment key={variation.id}>
                {/* Generation 2 Label */}
                {showGen2Label && (
                  <div style={{
                    background: 'rgba(150, 206, 180, 0.1)',
                    padding: '15px',
                    borderRadius: '10px',
                    marginBottom: '20px',
                    border: '1px solid rgba(150, 206, 180, 0.3)',
                    textAlign: 'center'
                  }}>
                    <h4 style={{ margin: 0, color: '#96CEB4' }}>
                      🧬 Generation 2: Evolved Solutions
                    </h4>
                    <p style={{ margin: '5px 0 0 0', fontSize: '13px', opacity: 0.8 }}>
                      Genetic crossover and mutation applied to best Gen 1 solutions
                    </p>
                  </div>
                )}
                
                {/* Final Generation Label */}
                {showFinalLabel && (
                  <div style={{
                    background: 'rgba(221, 160, 221, 0.1)',
                    padding: '15px',
                    borderRadius: '10px',
                    marginBottom: '20px',
                    border: '1px solid rgba(221, 160, 221, 0.3)',
                    textAlign: 'center'
                  }}>
                    <h4 style={{ margin: 0, color: '#DDA0DD' }}>
                      🏆 Final Evolution: Production Ready
                    </h4>
                    <p style={{ margin: '5px 0 0 0', fontSize: '13px', opacity: 0.8 }}>
                      Best solution after multiple generations of evolution and testing
                    </p>
                  </div>
                )}
                
                <div style={{
                  background: variation.best 
                    ? `linear-gradient(135deg, ${variation.color}20, ${variation.color}10)`
                    : 'rgba(255, 255, 255, 0.05)',
                  padding: '25px',
                  borderRadius: '12px',
                  border: variation.best 
                    ? `2px solid ${variation.color}60`
                    : '1px solid rgba(255, 255, 255, 0.1)',
                  marginBottom: '20px'
                }}>
                  <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    marginBottom: '20px'
                  }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: '10px',
                        marginBottom: '8px'
                      }}>
                        {variation.agent && (
                          <span style={{
                            background: `${variation.color}20`,
                            color: variation.color,
                            padding: '4px 10px',
                            borderRadius: '6px',
                            fontSize: '13px',
                            fontWeight: '600'
                          }}>
                            {variation.agent}
                          </span>
                        )}
                      </div>
                      <h4 style={{ 
                        margin: '0 0 8px 0',
                        color: variation.color,
                        fontSize: '20px',
                        fontWeight: '600'
                      }}>
                        {variation.version}
                      </h4>
                      <p style={{ 
                        margin: 0, 
                        fontSize: '14px',
                        opacity: 0.9
                      }}>
                        {variation.approach}
                      </p>
                    </div>
                    <div style={{ textAlign: 'right' }}>
                      <div style={{
                        background: variation.best ? variation.color : 'rgba(78, 205, 196, 0.2)',
                        color: variation.best ? 'white' : variation.color,
                        padding: '8px 16px',
                        borderRadius: '20px',
                        fontSize: '16px',
                        fontWeight: '700',
                        marginBottom: '8px'
                      }}>
                        Score: {variation.score}/5
                      </div>
                      {variation.best && (
                        <span style={{
                          background: 'linear-gradient(135deg, #DDA0DD, #96CEB4)',
                          color: 'white',
                          padding: '4px 12px',
                          borderRadius: '12px',
                          fontSize: '12px',
                          fontWeight: '600'
                        }}>
                          BEST SOLUTION
                        </span>
                      )}
                    </div>
                  </div>
              
              <div style={{ marginBottom: '20px' }}>
                <strong style={{ color: variation.color, fontSize: '14px' }}>Key Changes:</strong>
                <ul style={{ margin: '8px 0 0 20px', paddingLeft: '0' }}>
                  {variation.changes.map((change, idx) => (
                    <li key={idx} style={{ 
                      marginBottom: '4px',
                      fontSize: '13px',
                      opacity: 0.9
                    }}>
                      {change}
                    </li>
                  ))}
                </ul>
              </div>
                  
                  <div style={{
                    background: 'rgba(0, 0, 0, 0.4)',
                    borderRadius: '8px',
                    marginBottom: '15px',
                    overflow: 'hidden'
                  }}>
                    <div 
                      style={{ 
                        padding: '15px',
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        borderBottom: expandedCode[variation.id] ? '1px solid rgba(255, 255, 255, 0.1)' : 'none'
                      }}
                      onClick={() => toggleCode(variation.id)}
                    >
                      <div style={{ 
                        fontSize: '12px', 
                        fontWeight: '600',
                        color: variation.color
                      }}>
                        Code Preview
                      </div>
                      <span style={{ fontSize: '12px', opacity: 0.7 }}>
                        {expandedCode[variation.id] ? '▼' : '▶'}
                      </span>
                    </div>
                    {expandedCode[variation.id] && (
                      <div style={{ 
                        padding: '15px',
                        maxHeight: '400px',
                        overflow: 'auto'
                      }}>
                        <pre style={{ 
                          margin: 0,
                          fontSize: '12px',
                          lineHeight: '1.5',
                          color: '#ddd',
                          whiteSpace: 'pre-wrap'
                        }}>
                          {variation.codePreview}
                        </pre>
                      </div>
                    )}
                  </div>
                  
                  <div style={{ 
                    display: 'flex', 
                    gap: '20px',
                    fontSize: '13px',
                    paddingTop: '15px',
                    borderTop: '1px solid rgba(255, 255, 255, 0.1)'
                  }}>
                    <span>Speed: <strong style={{ color: '#4ECDC4' }}>{variation.metrics.speed}</strong></span>
                    <span>Memory: <strong style={{ color: '#96CEB4' }}>{variation.metrics.memory}</strong></span>
                    <span>Readability: <strong style={{ color: '#DDA0DD' }}>{variation.metrics.readability}</strong></span>
                  </div>
                </div>
              </React.Fragment>
            );
          })}
        </div>
        
        {/* Evolution Process Visualization */}
        <div style={{
          marginTop: '40px',
          padding: '30px',
          background: 'linear-gradient(135deg, rgba(78, 205, 196, 0.1), rgba(150, 206, 180, 0.1))',
          borderRadius: '16px',
          border: '1px solid rgba(78, 205, 196, 0.3)'
        }}>
          <h3 style={{ 
            margin: '0 0 25px 0', 
            fontSize: '24px',
            color: '#4ECDC4'
          }}>
            🧬 Evolution Process Details
          </h3>
          
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '20px'
          }}>
            {/* Genetic Operations */}
            <div style={{
              background: 'rgba(255, 255, 255, 0.05)',
              padding: '20px',
              borderRadius: '10px',
              border: '1px solid rgba(255, 255, 255, 0.1)'
            }}>
              <h4 style={{ margin: '0 0 15px 0', color: '#FF6B6B' }}>
                🔀 Crossover Operation
              </h4>
              <p style={{ margin: '0 0 10px 0', fontSize: '13px', opacity: 0.9 }}>
                Combines the best features from different variations:
              </p>
              <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '12px', lineHeight: '1.8' }}>
                <li>Performance Agent's async/await patterns</li>
                <li>Clean Code Agent's error handling</li>
                <li>Memory Optimizer's efficient structures</li>
                <li>Creates hybrid solutions with combined strengths</li>
              </ul>
            </div>
            
            <div style={{
              background: 'rgba(255, 255, 255, 0.05)',
              padding: '20px',
              borderRadius: '10px',
              border: '1px solid rgba(255, 255, 255, 0.1)'
            }}>
              <h4 style={{ margin: '0 0 15px 0', color: '#96CEB4' }}>
                🧬 Mutation Operation
              </h4>
              <p style={{ margin: '0 0 10px 0', fontSize: '13px', opacity: 0.9 }}>
                Introduces random beneficial changes:
              </p>
              <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '12px', lineHeight: '1.8' }}>
                <li>Add new optimization techniques</li>
                <li>Modify algorithm implementations</li>
                <li>Introduce novel patterns</li>
                <li>15% mutation rate for diversity</li>
              </ul>
            </div>
            
            <div style={{
              background: 'rgba(255, 255, 255, 0.05)',
              padding: '20px',
              borderRadius: '10px',
              border: '1px solid rgba(255, 255, 255, 0.1)'
            }}>
              <h4 style={{ margin: '0 0 15px 0', color: '#DDA0DD' }}>
                🏆 Selection Process
              </h4>
              <p style={{ margin: '0 0 10px 0', fontSize: '13px', opacity: 0.9 }}>
                Elite solutions survive to next generation:
              </p>
              <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '12px', lineHeight: '1.8' }}>
                <li>Top 30% by performance score</li>
                <li>20% by code quality metrics</li>
                <li>10% random for diversity</li>
                <li>Tournament selection for breeding</li>
              </ul>
            </div>
          </div>
          
          {/* Scoring Criteria */}
          <div style={{
            marginTop: '25px',
            padding: '20px',
            background: 'rgba(0, 0, 0, 0.2)',
            borderRadius: '10px'
          }}>
            <h4 style={{ margin: '0 0 15px 0', color: '#4ECDC4' }}>
              📊 Multi-Dimensional Scoring System
            </h4>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
              gap: '15px',
              fontSize: '13px'
            }}>
              <div>
                <strong style={{ color: '#FF6B6B' }}>Performance (40%)</strong>
                <ul style={{ margin: '5px 0 0 20px', paddingLeft: 0, opacity: 0.9 }}>
                  <li>Execution speed</li>
                  <li>Time complexity</li>
                  <li>Resource usage</li>
                </ul>
              </div>
              <div>
                <strong style={{ color: '#96CEB4' }}>Code Quality (30%)</strong>
                <ul style={{ margin: '5px 0 0 20px', paddingLeft: 0, opacity: 0.9 }}>
                  <li>Readability</li>
                  <li>Maintainability</li>
                  <li>Best practices</li>
                </ul>
              </div>
              <div>
                <strong style={{ color: '#DDA0DD' }}>Reliability (30%)</strong>
                <ul style={{ margin: '5px 0 0 20px', paddingLeft: 0, opacity: 0.9 }}>
                  <li>Error handling</li>
                  <li>Type safety</li>
                  <li>Test coverage</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        
        {/* Key Benefits */}
        <div style={{
          marginTop: '30px',
          padding: '20px',
          background: 'rgba(78, 205, 196, 0.1)',
          borderRadius: '10px',
          border: '1px solid rgba(78, 205, 196, 0.3)'
        }}>
          <h4 style={{ margin: '0 0 10px 0', color: '#4ECDC4' }}>
            💡 Why Artemis Single File Evolution?
          </h4>
          <p style={{ margin: 0, fontSize: '14px', lineHeight: '1.8', opacity: 0.9 }}>
            Unlike traditional single-agent approaches that provide one solution, Artemis creates a 
            population of solutions and evolves them through multiple generations. This genetic 
            programming approach ensures you get the best possible optimization for your specific 
            use case, with full transparency into the evolution process and scoring criteria.
          </p>
        </div>
      </div>
      

    </div>
  );
};

export default AIVariations; 